import { Box, ColorOptions, IconNew, IconNewOptions, TextNew } from '@jfs/ui-new'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { styles } from './styles'
import { DropDownBoxInterface, DropdownTypes } from './types'

export const DropDownBox = ({
  showBorder,
  isIconAvailable,
  onLayout,
  toggleDropdown,
  iconType,
  defaultLabel,
  dropdownVisible,
  type,
  value,
  clearSelection,
  chevronColor,
  disabled,
  disabledBg,
  borderColor = 'DISABLED_GREY',
  testID,
  buttonWidth = undefined,
  titleColor,
  fontWeight,
  boxheight = 35,
}: DropDownBoxInterface) => {
  const handlePress = (evt: any) => {
    toggleDropdown(true)
    onLayout &&
      onLayout({
        left: evt.nativeEvent.pageX - evt.nativeEvent.layerX,
        top: evt.nativeEvent.pageY - evt.nativeEvent.layerY,
      })
  }

  const showHighlight = type === DropdownTypes.SELECTABLE_HIGHLIGHT && value?.length > 0
  const defaultBorderColor = showHighlight ? 'BLUE' : borderColor
  const bgColor =
    type === DropdownTypes.DEFAULT_WITH_BG
      ? ('#0186B014' as ColorOptions)
      : disabled
        ? (disabledBg as ColorOptions)
        : type === DropdownTypes.ADD_BENEFICIARY
          ? 'PRIMARY'
          : 'WHITE'
  const boxHeight =
    type === DropdownTypes.DEFAULT_WITH_BG ? 20 : type === DropdownTypes.DEFAULT_DOWNLOAD_REPORT ? 36 : boxheight
  const textColor = titleColor !== undefined ? titleColor : type === DropdownTypes.DEFAULT_WITH_BG ? 'BLUE' : 'BLACK_21'
  return (
    <Box width={buttonWidth} testID={`${testID}-wrapper`}>
      <ModBox
        show={!showHighlight}
        {...styles.overlayStyle}
        testID={'dropdown-overlay'}
        onPress={handlePress}
        disabled={disabled}
      />
      <Box
        {...styles.dropdownBox(showBorder, isIconAvailable, defaultBorderColor, boxHeight, bgColor, type)}
        onPress={handlePress}
        disabled={disabled}
        testID={testID}>
        <ModBox show={iconType !== null} {...styles.iconContainer}>
          <IconNew hide={iconType === null} id={iconType as IconNewOptions} size={16} color="BLACK_21" />
        </ModBox>
        <ModBox
          show={defaultLabel !== (null || '')}
          {...styles.labelContainer}
          f={1}
          align={'flex-start'}
          pl={type === DropdownTypes.DEFAULT_WITH_BG || type === DropdownTypes.RADIO_BUTTON ? 8 : 15}>
          <TextNew
            {...styles.label}
            color={disabled ? 'BLACK_LIGHT' : textColor}
            fontWeight={fontWeight}
            numberOfLines={1}>
            {defaultLabel}
          </TextNew>
        </ModBox>
        <Box
          {...styles.dropdownIconContainer}
          testID="clearSelection"
          onPress={() => showHighlight && clearSelection()}>
          <IconNew
            id={disabled ? 'LOCK' : dropdownVisible ? 'ARROW_UP' : showHighlight ? 'CLEAR' : 'ARROW_DOWN'}
            size={16}
            color={disabled ? 'BLACK_LIGHT' : chevronColor ?? 'BLACK_21'}
          />
        </Box>
      </Box>
    </Box>
  )
}
